<div [ngClass]="[showRecap == false ? 'globalContainer' : 'globalContainer opacited']">
    <div class="topFormContainer" id="topFormContainer">
        <div class="formContainer" id="formContainer">
            <div id="fakeFormContainer" class="fakeFormContainer" (click)="launchBigForm()">
                <mat-icon>search</mat-icon>
                <span
                    *ngIf="
                        (campaignName.value == null || campaignName.value == '') &&
                        (locationSearch.value == null || locationSearch.value == '') &&
                        startDate.value == null &&
                        endDate.value == null
                    "
                    >Définir votre diffusion</span
                >
                <span class="maxWidthSpan" *ngIf="campaignName.value != null && campaignName.value != ''">{{
                    campaignName.value
                }}</span>
                <span
                    class="hrFake"
                    *ngIf="
                        campaignName.value != null &&
                        (locationSearch.value != null || startDate.value != null || endDate.value != null)
                    "
                ></span>
                <span class="maxWidthSpan" *ngIf="locationSearch.value != null && locationSearch.value != ''">{{
                    locationSearch.value
                }}</span>
                <span
                    class="hrFake"
                    *ngIf="locationSearch.value != null && (startDate.value != null || endDate.value != null)"
                ></span>
                <span class="maxWidthSpanDate" *ngIf="startDate.value != null">{{
                    startDate.value | date: 'dd/MM/YY'
                }}</span>
                <span class="maxWidthSpanDate" *ngIf="endDate.value != null" style="margin-left: 5px">
                    - {{ endDate.value | date: 'dd/MM/YY' }}</span
                >
            </div>
            <button class="closeBigForm" id="closeBigForm" mat-stroked-button (click)="closeBigForm()">Fermer</button>

            <h4 id="bigFormTitle">Définissez votre diffusion</h4>
            <!-- Champs pour le nom de la campagne -->
            <mat-form-field class="campaignName campaignNameField hiddenFormField" id="campaignName" width="100%">
                <mat-icon matPrefix>campaign</mat-icon>
                <mat-label>Nom de la campagne</mat-label>
                <input
                    type="text"
                    name="campaignName"
                    matInput
                    #campaignNameInput
                    required
                    maxlength="30"
                    placeholder="Ex: Ma Campagne..."
                    [formControl]="campaignName"
                />
            </mat-form-field>
            <!-- Selection des dates de diffusion -->
            <mat-form-field
                class="rangeSelector hiddenFormField"
                id="dateInput"
                width="100%"
                (click)="showPicker($event)"
            >
                <mat-label>Dates de diffusion*</mat-label>
                <mat-date-range-input (click)="showPicker($event)" [min]="today" [rangePicker]="picker">
                    <input
                        (click)="showPicker($event)"
                        matStartDate
                        #dateInput
                        [(ngModel)]="startDate.value"
                        (ngModelChange)="dateRangeChange()"
                        placeholder="Début"
                        clickMapMarker
                    />
                    <input
                        matEndDate
                        (click)="showPicker($event)"
                        [(ngModel)]="endDate.value"
                        (ngModelChange)="dateRangeChange()"
                        placeholder="Fin"
                    />
                </mat-date-range-input>
                <mat-datepicker-toggle id="datePickerToggle" matIconPrefix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker [touchUi]="true" #picker></mat-date-range-picker>
            </mat-form-field>
            <!-- Selection de l'adresse cible -->
            <mat-form-field class="locationSearch hiddenFormField" id="locationSearch" width="100%">
                <mat-icon matPrefix style="margin-top: -24px">pin_drop</mat-icon>
                <mat-label>Adresse</mat-label>
                <textarea
                    type="text"
                    name="locationSearch"
                    id="locationSearchInput"
                    matInput
                    autocomplete="address-level1"
                    [formControl]="locationSearch"
                    [matAutocomplete]="auto"
                >
                </textarea>
                <mat-icon
                    matSuffix
                    style="margin-top: -14px"
                    *ngIf="locationSearch.value != null"
                    (click)="locationSearch.setValue(null)"
                    >close</mat-icon
                >
            </mat-form-field>
            <mat-autocomplete #auto="matAutocomplete">
                <mat-option *ngFor="let option of locationOptions" (click)="selectedPlace(option)" [value]="option">
                    <span class="placeOption" style="line-height: 2px !important">{{ option }}</span>
                </mat-option>
            </mat-autocomplete>
        </div>

        <!-- Erreur si écrans pas bons -->
        <article *ngIf="!isSelectionOK" class="warningCartContainer" (click)="goToRecap()">
            <hr />
            <mat-icon class="cartIcon">warning</mat-icon>
            <span>Des écrans parmi votre sélection requièrent votre attention !</span>
            <span class="cartNext">Résoudre</span>
        </article>
    </div>

    <div id="screenList" [ngClass]="[!displayList ? 'hideList' : '']">
        <div id="expandRight" (click)="reduceScreenList()">
            <mat-icon>expand_less</mat-icon>
        </div>

        <!-- MARK: OLD Sélection de plusieurs écrans -->
        <div class="selectManyContainer" style="display: none">
            <h1 style="padding-left: 10px; margin-bottom: 4px">
                <span class="material-icons" style="vertical-align: sub; margin-right: 6px; font-size: 20px"> map </span
                >Sélection via la carte
            </h1>
            <article class="screenParkContainer" id="dooh">
                <div>
                    <mat-icon
                        style="height: 25px; width: 25px"
                        alt="Ecran outdoor"
                        class="screenTypeImg"
                        svgIcon="store-outdoor"
                    ></mat-icon>
                    <span>Ecrans Géants bord de route</span>

                    <article matRipple (click)="SelectScreenInZone(1, false)">
                        <mat-icon class="cartIcon" svgIcon="crossedPinkMarker"></mat-icon>
                        <span class="buttonText">Aucun</span>
                    </article>
                    <article matRipple (click)="SelectScreenInZone(1, true)">
                        <mat-icon class="cartIcon" svgIcon="manyPinkMarker"></mat-icon>
                        <span class="buttonText">Tous</span>
                    </article>
                </div>
            </article>
            <article class="screenParkContainer" style="margin-top: 20px" id="indoor">
                <div>
                    <mat-icon
                        style="height: 25px; width: 25px"
                        alt="Ecran indoor"
                        class="screenTypeImg"
                        svgIcon="store-indoor"
                    ></mat-icon>
                    <span>Ecrans intérieurs</span>
                    <article (click)="SelectScreenInZone(14, false)">
                        <mat-icon class="cartIcon" svgIcon="crossedBlueMarker"></mat-icon>
                        <span class="buttonText">Aucun</span>
                    </article>
                    <article (click)="SelectScreenInZone(14, true)">
                        <mat-icon class="cartIcon" svgIcon="manyBlueMarker"></mat-icon>
                        <span class="buttonText">Tous</span>
                    </article>
                </div>
            </article>
        </div>

        <!-- MARK: Liste des écrans à gauche -->
        <!-- <hr style="display: block; margin-top: 15px; margin-left: auto; margin-right: auto; width: 90%; opacity: 0.4" /> -->
        <h1 class="screenListTitle">Ecrans disponibles</h1>

        @if (isScreenListLoading) {
            <div class="screenListLoader">
                <mat-spinner [diameter]="30"></mat-spinner>
                <i>Récupération des écrans ...</i>
            </div>
        }

        <div
            class="screenItems"
            id="scrList"
            infiniteScroll
            [infiniteScrollDistance]="2"
            [infiniteScrollThrottle]="50"
            (scrolled)="onScroll()"
            [scrollWindow]="false"
            style="overflow-y: scroll"
            (window:resize)="onResize($event)"
            *ngIf="screenList.length != null && screenList.length != 0"
        >
            <ng-container *ngFor="let sl of screenList">
                <ng-container *ngFor="let face of sl.fAs; let first = first">
                    <app-map-item
                        [hasDateSelected]="startDate.value != null && endDate.value != null"
                        [screenItem]="sl"
                        [faceItem]="face"
                        (clickScreenFromMapOutput)="clickScreenFromMap($event)"
                        (openInfoOutput)="openInfo($event)"
                        [mapMode]="false"
                    ></app-map-item>
                </ng-container>
            </ng-container>
        </div>
    </div>

    <!-- MAP -->
    <google-map
        [ngClass]="[!displayMap ? 'hideMap' : '']"
        height="100%"
        width="100%"
        id="map"
        [center]="center"
        [zoom]="mapOptions.zoom"
        (mapDragend)="triggerEvent('map', 'dragend')"
        #map
        [options]="mapOptions"
    >
        <!-- Icones -->
        <map-marker
            #somemarker="mapMarker"
            *ngFor="let marker of markers"
            id="marker{{ marker.i }}"
            [position]="marker.position"
            [options]="marker.option"
            (mapClick)="clickMapMarker(somemarker, marker.i)"
            (click)="openInfo(marker.i, somemarker)"
        >
        </map-marker>
        <!-- Fenetre d'info de l'icone -->
        <map-info-window *ngIf="!mobile">
            @if (locationInformation != null) {
                <ng-container *ngFor="let face of locationInformation.fAs; let first = first">
                    <app-map-item
                        [hasDateSelected]="startDate.value != null && endDate.value != null"
                        [screenItem]="locationInformation"
                        [faceItem]="face"
                        (clickScreenFromMapOutput)="clickScreenFromMap($event)"
                        (selectFaceFromMapOutput)="selectFaceFromMap($event)"
                        (openInfoOutput)="openInfo($event)"
                        [mapMode]="true"
                    ></app-map-item>
                </ng-container>
            } @else {
                <div class="loadingIW">
                    <mat-spinner [diameter]="40"></mat-spinner>
                    <i>Chargement des informations de l'écran ...</i>
                </div>
            }
            <button class="closeMapInfo" mat-stroked-button (click)="info.close(); selectedMapMarker = null">
                Fermer
            </button>
        </map-info-window>
    </google-map>

    @if (displayList) {
        <!-- Zoom - -->
        <article class="floatyBtn lessButton" (click)="moveZoom(false)">
            <span class="material-icons-outlined cartIcon">remove</span>
        </article>

        <!-- Zoom + -->
        <article class="floatyBtn plusButton" (click)="moveZoom(true)">
            <span class="material-icons-outlined cartIcon">add</span>
        </article>
    }

    <article *ngIf="locationInformation != null && mobile && displayMap" class="floatingScreensContainer">
        <div>
            <ng-container *ngFor="let face of locationInformation.fAs; let first = first">
                <app-map-item
                    [screenItem]="locationInformation"
                    [faceItem]="face"
                    [mini]="true"
                    (closePopup)="closePopup()"
                    (clickScreenFromMapOutput)="clickScreenFromMap($event)"
                    (selectFaceFromMapOutput)="selectFaceFromMap($event)"
                    (openInfoOutput)="openInfo($event)"
                    [mapMode]="true"
                ></app-map-item>
            </ng-container>
        </div>
    </article>
</div>

<!-- Récap et panier -->
<div *ngIf="showRecap == true" class="shadowDiv"></div>
<article class="cartContainer" (click)="goToRecap()">
    <span class="material-icons-outlined cartIcon">shopping_cart</span>
    <div>
        <span class="screenCount" [@textFade]>
            <ng-container *ngIf="selectedFaceIds != [] && selectedFaceIds.length != 0"
                >{{ selectedFaceIds.length }} <span> écran(s)</span></ng-container
            >
            <ng-container *ngIf="selectedFaceIds == [] || selectedFaceIds.length == 0" [@textFade]
                >0 écran</ng-container
            ></span
        >

        @if (cartPriceHT != null) {
            <span class="screenCount" [@textFade]>{{
                cartPriceHT | currency: 'EUR' : 'symbol' : undefined : 'fr'
            }}</span>
        }
    </div>
</article>
<article *ngIf="displayList" class="mapButton" (click)="displayMap = true; displayList = false; closeBigForm()">
    <span class="material-icons-outlined cartIcon">map</span>
    <span>Carte</span>
</article>

<article *ngIf="displayMap" class="mapButton" (click)="displayList = true; displayMap = false; closeBigForm()">
    <span class="material-icons-outlined cartIcon">format_list_bulleted</span>
    <span>Liste</span>
</article>
<!-- Bouton Suivant -->
<article [ngClass]="[canNext ? 'nextContainer' : 'nextContainer disabledNext']" (click)="next()">
    <div>
        <span class="screenCount">{{ nextText }}</span>
    </div>
    <span class="material-icons cartIcon">navigate_next</span>
</article>
